import { useMutation, useQueryClient } from "@tanstack/react-query"
import { smartSyncDeal } from "@/api"

export const useSyncDealFromLegacy = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (dealId: number) => smartSyncDeal(dealId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["dealInfo"] })
      queryClient.invalidateQueries({ queryKey: ["companyInfo"] })
      queryClient.invalidateQueries({ queryKey: ["dealLogs"] })
    },
  })
}
